// extracted by mini-css-extract-plugin
export default {"footer":"classes_footer__NZiq7","message":"classes_message__eJ8kW","heart":"classes_heart__AMeg-","heartbeat":"classes_heartbeat__uTo5j"};